import React from 'react';
import {
    Table, TableBody, TableCell, TableHead, TableRow,
    Button, withStyles, Typography
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { db } from '../../firebase/firebase';
import { getTasks } from '../../firebase/db';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const styles = theme => ({
    root: {
        width: '90%',
        marginTop: 20,
        overflowX: 'auto',
    },
    table: {
        minWidth: 600,
        marginTop: 40
    },
    container: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
    },
    editButton: {
        marginLeft: 20
    }
});

class WorkerSubTaskList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collaborators: [],
            tasks: this.props.location.state.tasks,
            title: this.props.location.state.title
        };
    }

    componentDidMount() {
        const { location: { state: { projectId } }, auth } = this.props;
        db.ref('subTasks').limitToLast(1).on('child_added', () => {
            getTasks(projectId, auth.email)
                .then((tasks) => this.setState({ tasks }));
        });
        db.ref('subTasks').on('child_changed', () => {
            getTasks(projectId, auth.email)
                .then((tasks) => this.setState({ tasks }))
        });
        db.ref('subTasks').on('child_removed', () => {
            getTasks(projectId, auth.email)
                .then((tasks) => this.setState({ tasks }));
        });
    }

    componentWillUnmount() {
        db.ref('subTasks').off();
    }

    onEditClick = (row, title) => {
        const { history, auth } = this.props;
        history.push('worker_task_detail', { row, title, auth });
    }

    render() {
        const { classes } = this.props;
        const { tasks, title } = this.state;
        const renderedTasks =
            tasks.map((row) => {
                if (!row) return null;
                const index = row.cycles.index + 1;
                return (
                    <TableRow>
                        <CustomTableCell component="th" scope="row">{row.subTask.finished ? 'Finished' : 'Open'}</CustomTableCell>
                        <CustomTableCell>
                            {row.task.name}
                            <Button
                                className={classes.editButton}
                                color="primary"
                                aria-label="Add"
                                onClick={() => this.onEditClick(row, title)}
                            >
                                <EditIcon />
                            </Button>
                        </CustomTableCell>
                        <CustomTableCell>{row.subTask.createdOn ? (new Date(row.subTask.createdOn)).toLocaleDateString('de-AT') : '/'}</CustomTableCell>
                        <CustomTableCell>{row.cycles.title + ' [' + index + ']'}</CustomTableCell>
                        <CustomTableCell>{row.subTask.endDate ? row.subTask.endDate : '/'}</CustomTableCell>
                        <CustomTableCell>{window.atob(row.task.manager)}</CustomTableCell>
                    </TableRow>
                );
            })
        return (
            <div className={classes.container}>
                <div className={classes.root}>
                    <Typography variant="headline" color="secondary" >{`Task list`}</Typography>
                    <Typography variant="title" color="secondary" gutterBottom>{`Project: ${title}`}</Typography>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <CustomTableCell>State</CustomTableCell>
                                <CustomTableCell >Task</CustomTableCell>
                                <CustomTableCell >Creation date</CustomTableCell>
                                <CustomTableCell >Cycle title and number</CustomTableCell>
                                <CustomTableCell >Due date</CustomTableCell>
                                <CustomTableCell >Manager</CustomTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {renderedTasks}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(WorkerSubTaskList);


// WEBPACK FOOTER //
// ./src/components/Tasks/WorkerSubTaskList.js